import React from 'react';
import { Helmet } from 'react-helmet';
import "../../Desktop/InsightDetailPage/InsightDetailPage.css";

export default function InsightsDetails(props) {
  
  return (
    <>    
        <div className="idpd-frame-1586">
          <Helmet>
          <title>{props.metaTitle}</title>
          <meta name="keywords" content={props.metaKeyword}/>
          <meta name="description" content={props.metaDescription}/>
          </Helmet>
          <h1 className="idpd-title idpd-valign-text-middle idpd-typographyheadlineh2-extrabold-40">{props.title}</h1>
          {/* <img className="idpd-rectangle-85" src={rectangle85} /> */}
          <img className="idpd-rectangle-85" src={props.mainImg} />
          <div className="idpd-group-195">
            <p className="idpd-text-28 idpd-typographybody16-regular">
              {/* <span className="idpd-typographybody16-regular">{spanText}</span>
              <span className="idpd-span-1 idpd-overpass-bold-shark-16px">{spanText2}</span>
              <span className="idpd-typographybody16-regular">{spanText3}</span>
              <span className="idpd-span-1 idpd-overpass-bold-shark-16px">{spanText4}</span> */}
              <span className="idpd-typographybody16-regular">{props.detail}</span>
            </p>
            <div className="idpd-text-29 idpd-valign-text-middle idpd-typographyheadlineh2-extrabold-40">{props.subTitle}</div>
          </div>
          {/* <img className="idpd-image-9" src={image9} /> */}
          <img className="idpd-image-9" src={props.subImg} /> 
          
          <p className="idpd-text-30 idpd-valign-text-middle idpd-typographybody16-regular">
            <span>
              <span className="idpd-span0 idpd-typographybody16-regular">{props.description}</span>
              <span className="idpd-span-1 idpd-overpass-semi-bold-mahogany-16px">{props.link1}</span>
              {/* <span className="idpd-span-1 idpd-overpass-semi-bold-shark-16px">{spanText8}</span> */}
              <span className="idpd-span-1 idpd-overpass-semi-bold-silver-16px">{props.separator}</span>
              {/* <span className="idpd-span-1 idpd-overpass-semi-bold-shark-16px">{spanText10}</span> */}
              <span className="idpd-span-1 idpd-overpass-semi-bold-mahogany-16px">{props.link2}</span>
              {/* <span className="idpd-span-1 idpd-overpass-semi-bold-shark-16px">{spanText12}</span> */}
              <span className="idpd-span-1 idpd-overpass-semi-bold-silver-16px">{props.separator}</span>
              {/* <span className="idpd-span-1 idpd-overpass-semi-bold-shark-16px">{spanText14}</span> */}
              <span className="idpd-span-1 idpd-overpass-semi-bold-mahogany-16px">{props.link3}</span>
              <span className="idpd-span-1 idpd-overpass-semi-bold-silver-16px">{props.separator}</span>
              <span className="idpd-span-1 idpd-overpass-semi-bold-mahogany-16px">{props.link4}</span>
              <span className="idpd-span-1 idpd-overpass-semi-bold-silver-16px">{props.separator}</span>
              <span className="idpd-span-1 idpd-overpass-semi-bold-mahogany-16px">{props.link5}</span>
              <span className="idpd-span-1 idpd-overpass-semi-bold-silver-16px">{props.separator}</span>
              <span className="idpd-span-1 idpd-overpass-semi-bold-mahogany-16px">{props.link6}</span>
              <span className="idpd-span-1 idpd-overpass-semi-bold-silver-16px">{props.separator}</span>
              <span className="idpd-span-1 idpd-overpass-semi-bold-mahogany-16px">{props.link7}</span>
              <span className="idpd-span-1 idpd-overpass-semi-bold-silver-16px">{props.separator}</span>
              <span className="idpd-span-1 idpd-overpass-semi-bold-mahogany-16px">{props.link8}</span>
              <span className="idpd-span-1 idpd-overpass-semi-bold-silver-16px">{props.separator}</span>
              <span className="idpd-span-1 idpd-overpass-semi-bold-mahogany-16px">{props.link9}</span>
              <span className="idpd-span-1 idpd-overpass-semi-bold-silver-16px">{props.separator}</span>
              <span className="idpd-span-1 idpd-overpass-semi-bold-mahogany-16px">{props.link10}</span>
              <span className="idpd-span-1 idpd-overpass-semi-bold-silver-16px">{props.separator}</span>
              <span className="idpd-span-1 idpd-overpass-semi-bold-mahogany-16px">{props.link11}</span>
            </span>
            <br/>
            <span className="idpd-span0 idpd-typographybody16-regular">{props.subDescription}</span>
          </p>
        </div>   
    </>
  );
}

